require('./club.module');
require('./controllers/edit.controller');
require('./controllers/membership.controller');
require('./controllers/members_list.controller');
require('./controllers/events.controller');